module.exports = __webpack_public_path__ + "assets/img/1.cdfe9bb1.jpg";